import { FiSearch, FiX } from "react-icons/fi";

const Search = ({ input, handleChange, clearSearch }) => {
  return (
    <div className="relative w-full max-w-md">
      <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />

      <input
        type="text"
        value={input}
        onChange={handleChange}
        placeholder="Search for a country..."
        className="w-full pl-12 pr-12 py-3 rounded-xl bg-white dark:bg-containerColor shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all placeholder:text-gray-400 dark:text-white"
      />

      {input && (
        <button
          type="button"
          onClick={clearSearch}
          className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 dark:hover:text-white transition"
          aria-label="Clear search"
        >
          <FiX className="text-lg" />
        </button>
      )}
    </div>
  );
};

export default Search;
